:host(.horizontal) {
  @include mobile {
    .description {
      display: none;
      visibility: hidden;
    }
  }
  @include tablet {
    .description {
      display: flex;
      visibility: visible;
    }
  }
  @include desktop {
    .description {
      display: flex;
      visibility: visible;
    }
  }
}

:host(.vertical) {
  @include mobile {
    padding-bottom: 0px;
    .description {
      display: none;
      visibility: hidden;
    }
  }
  @include tablet {
    padding-bottom: 21px;
    .description {
      display: flex;
      visibility: visible;
    }
  }
  @include desktop {
    .description {
      display: flex;
      visibility: visible;
    }
  }
}

.step-parent {
  position: relative;
  display: flex;
}

.step-child {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  font: $xp-ref-font-headline-headline06;
  text-align: center;

  &.to-be-done {
    border: 1px solid $xp-ref-color-border-heavy;
    color: $xp-ref-color-text-default-dark;
  }

  &.current {
    background-color: $xp-ref-color-state-select;
    border: 1px solid $xp-ref-color-state-on-select;
    color: $xp-ref-color-state-on-select;
  }

  &.completed {
    color: $xp-ref-color-semantic-on-success;
    background-color: $xp-ref-color-semantic-success-high-emphasis;
    border: 1px solid transparent;
  }
}

.description {
  position: absolute;
  width: 100%;
  margin-top: 47px;
  font: $xp-ref-font-label-label-short;
  color: $xp-ref-color-text-default-dark;

  &.first {
    justify-content: start;
  }

  &.middle {
    justify-content: center;
  }

  &.last {
    justify-content: end;
  }
}
